import Image from "next/image";
import { cn } from "@/lib/utils";

const IQUD_LOGO_URL =
  "https://www.iqudtek.com/wp-content/uploads/2023/03/logo-iqud.webp";

type AmnealLogoProps = {
  className?: string;
  priority?: boolean;
};

export function AmnealLogo({ className, priority }: AmnealLogoProps) {
  return (
    <Image
      src={IQUD_LOGO_URL}
      alt="iQud"
      width={95}
      height={28}
      className={cn("h-7 w-auto shrink-0", className)}
      priority={priority}
      unoptimized
    />
  );
}
